export function toTurkishDate(dateString) {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("tr-TR", {
        day: "numeric",
        month: "long",
        year: "numeric"
    }).format(date);
}
